import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/@/components/ui/button';
import { Card, CardContent } from 'src/@/components/ui/card';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Badge } from 'src/@/components/ui/badge';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import { Separator } from 'src/@/components/ui/separator';
import { Label } from 'src/@/components/ui/label';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import v1_actionWboTemplates from 'src/actions/v1/meta/wbo/v1_actionWboTemplates';
import v1_actionWboCriarTemplate from 'src/actions/v1/meta/wbo/v1_actionWboCriarTemplate';
import v1_actionWboEditarTemplate from 'src/actions/v1/meta/wbo/v1_actionWboEditarTemplate';
import v1_actionWboDeletarTemplate from 'src/actions/v1/meta/wbo/v1_actionWboDeletarTemplate';
import v1_actionWboUploadMidiaTemplate from 'src/actions/v1/meta/wbo/v1_actionWboUploadMidiaTemplate';
import v1_actionWboObterTemplate from 'src/actions/v1/meta/wbo/v1_actionWboObterTemplate';
import v1_actionLibraryTemplates from 'src/actions/v1/library/v1_actionLibraryTemplates';

import { transformCategoryTemplateWhatsApp, transformStatusTemplateWhatsApp } from 'src/utils/meta.utils';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import actionListaCanaisPorCliente from 'src/actions/clientes/actionListaCanaisPorCliente';
import v1_actionWboTemplatesCategoryLogsNaoVistos from 'src/actions/v1/meta/wbo/v1_actionWboTemplatesCategoryLogsNaoVistos';
import GenericTable from '../../../../components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from '../../../../components/table/GenericTable.design';
import { TEMPLATES_WHATSAPP_DESIGN } from './TemplatesWhatsapp.design';

export default function TemplatesWhatsappPage() {
  const navigate = useNavigate();
  const { user, cliente } = useAuth();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lista, setLista] = useState([]);
  const [pesquisa, setPesquisa] = useState('');
  const [idEdit, setIdEdit] = useState(null);
  const [error, setError] = useState(null);
  const [canais, setCanais] = useState([]);
  const [canalFiltro, setCanalFiltro] = useState('all');
  const [categoriaFiltro, setCategoriaFiltro] = useState('all');
  const [mostrarBiblioteca, setMostrarBiblioteca] = useState(false);
  const [pesquisaBiblioteca, setPesquisaBiblioteca] = useState('');
  const [templatesBiblioteca, setTemplatesBiblioteca] = useState([]);
  const [loadingBiblioteca, setLoadingBiblioteca] = useState(false);
  const [paginacaoBiblioteca, setPaginacaoBiblioteca] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [logsNaoVistos, setLogsNaoVistos] = useState(0);

  // Estados do formulário
  const [nome, setNome] = useState('');
  const [categoria, setCategoria] = useState('');
  const [lingua, setLingua] = useState('pt_BR');
  const [conteudo, setConteudo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [tags, setTags] = useState('');
  const [canalId, setCanalId] = useState('');
  const [clienteIdTemplate, setClienteIdTemplate] = useState('');
  const [sessao, setSessao] = useState('');

  // Estados avançados
  const [parameterFormat, setParameterFormat] = useState('positional');
  const [headerType, setHeaderType] = useState('none');
  const [headerText, setHeaderText] = useState('');
  const [headerMedia, setHeaderMedia] = useState('');
  const [footerText, setFooterText] = useState('');
  const [buttons, setButtons] = useState([]);
  const [timeToLive, setTimeToLive] = useState(86400);

  // Estados para formulário de amostras de variáveis
  const [variaveisTemplate, setVariaveisTemplate] = useState({});
  const [errosValidacao, setErrosValidacao] = useState({});

  // Estado para amostras de variáveis em botões (ex: URL com {{1}})
  // Formato: { [indexBotao]: { [numVariavel]: 'valor_exemplo' } }
  const [variaveisBotoes, setVariaveisBotoes] = useState({});

  // Estado para upload de mídia do header
  const [headerMediaUploading, setHeaderMediaUploading] = useState(false);
  const [headerMediaFileName, setHeaderMediaFileName] = useState('');
  const [headerMediaMode, setHeaderMediaMode] = useState('upload'); // 'upload' | 'link'
  const [headerMediaPreview, setHeaderMediaPreview] = useState(''); // URL local para preview (blob)
  const [headerMediaFile, setHeaderMediaFile] = useState(null); // Arquivo raw para upload ao Meta
  const [headerMediaFilenameOriginal, setHeaderMediaFilenameOriginal] = useState(''); // Filename original do template (para edição sem trocar mídia)
  const headerFileInputRef = useRef(null);

  // Ref para o textarea do corpo da mensagem
  const textareaRef = useRef(null);

  // Biblioteca de modelos pré-prontos
  const modelosPreProntos = [
    {
      id: 'boas-vindas',
      nome: 'Boas Vindas',
      categoria: 'UTILITY',
      descricao: 'Template de boas-vindas para novos clientes',
      headerType: 'text',
      headerText: 'Bem-vindo à {{1}}!',
      conteudo: 'Olá {{1}}, seja bem-vindo(a)! Estamos muito felizes em tê-lo(a) conosco. Como podemos ajudá-lo(a) hoje?',
      footerText: 'Atenciosamente, Equipe {{1}}',
      buttons: [
        { type: 'QUICK_REPLY', text: 'Falar com atendente' },
        { type: 'QUICK_REPLY', text: 'Ver produtos' }
      ],
      variaveisExemplo: {
        '1': 'João Silva',
        '2': 'Empresa XYZ'
      }
    },
    {
      id: 'confirmacao-pedido',
      nome: 'Confirmação de Pedido',
      categoria: 'UTILITY',
      descricao: 'Confirmação de pedido com detalhes',
      headerType: 'text',
      headerText: 'Pedido Confirmado! 🎉',
      conteudo: 'Olá {{1}}, seu pedido #{{2}} foi confirmado com sucesso!\n\n📦 *Detalhes do pedido:*\n• Produto: {{3}}\n• Quantidade: {{4}}\n• Valor total: R$ {{5}}\n\nPrazo de entrega: {{6}} dias úteis.\n\nAcompanhe seu pedido em tempo real!',
      footerText: 'Obrigado pela sua compra!',
      buttons: [
        { type: 'URL', text: 'Rastrear pedido', url: 'https://exemplo.com/rastreio/{{2}}' },
        { type: 'QUICK_REPLY', text: 'Falar com suporte' }
      ],
      variaveisExemplo: {
        '1': 'Maria Santos',
        '2': '12345',
        '3': 'Produto Exemplo',
        '4': '2',
        '5': '199,90',
        '6': '5'
      }
    },
    {
      id: 'lembrete-pagamento',
      nome: 'Lembrete de Pagamento',
      categoria: 'UTILITY',
      descricao: 'Lembrete de pagamento pendente',
      headerType: 'text',
      headerText: 'Lembrete de Pagamento',
      conteudo: 'Olá {{1}}, lembramos que você possui uma fatura pendente.\n\n📋 *Detalhes:*\n• Valor: R$ {{2}}\n• Vencimento: {{3}}\n• Código de barras: {{4}}\n\nPor favor, efetue o pagamento para evitar interrupções no serviço.',
      footerText: 'Dúvidas? Entre em contato conosco.',
      buttons: [
        { type: 'QUICK_REPLY', text: 'Já paguei' },
        { type: 'QUICK_REPLY', text: 'Preciso de ajuda' }
      ],
      variaveisExemplo: {
        '1': 'Carlos Oliveira',
        '2': '150,00',
        '3': '15/12/2024',
        '4': '34191.09008 01234.567890 12345.678901 2 98760000015000'
      }
    },
    {
      id: 'promocao',
      nome: 'Promoção Especial',
      categoria: 'MARKETING',
      descricao: 'Template para campanhas promocionais',
      headerType: 'text',
      headerText: '🎁 Promoção Especial!',
      conteudo: 'Olá {{1}}, temos uma oferta especial para você!\n\n🔥 *Oferta por apenas R$ {{2}}*\n\nVálido até {{3}}. Não perca essa oportunidade!\n\nUse o cupom: {{4}}',
      footerText: 'Aproveite enquanto dura!',
      buttons: [
        { type: 'URL', text: 'Ver oferta', url: 'https://exemplo.com/promocao' },
        { type: 'QUICK_REPLY', text: 'Quero aproveitar' }
      ],
      variaveisExemplo: {
        '1': 'Ana Costa',
        '2': '99,90',
        '3': '31/12/2024',
        '4': 'PROMO2024'
      }
    },
    {
      id: 'agendamento',
      nome: 'Confirmação de Agendamento',
      categoria: 'UTILITY',
      descricao: 'Confirmação de agendamento de serviço',
      headerType: 'text',
      headerText: 'Agendamento Confirmado ✅',
      conteudo: 'Olá {{1}}, seu agendamento foi confirmado!\n\n📅 *Detalhes:*\n• Data: {{2}}\n• Horário: {{3}}\n• Serviço: {{4}}\n• Profissional: {{5}}\n\nLocal: {{6}}\n\nPor favor, chegue com 10 minutos de antecedência.',
      footerText: 'Esperamos você!',
      buttons: [
        { type: 'PHONE_NUMBER', text: 'Ligar para confirmar', phone_number: '+5511999999999' },
        { type: 'QUICK_REPLY', text: 'Reagendar' }
      ],
      variaveisExemplo: {
        '1': 'Roberto Silva',
        '2': '25/12/2024',
        '3': '14:00',
        '4': 'Consulta Médica',
        '5': 'Dr. João',
        '6': 'Rua Exemplo, 123 - São Paulo'
      }
    },
    {
      id: 'autenticacao',
      nome: 'Código de Autenticação',
      categoria: 'AUTHENTICATION',
      descricao: 'Envio de código de verificação',
      headerType: 'text',
      headerText: 'Código de Verificação',
      conteudo: 'Olá {{1}}, seu código de verificação é:\n\n🔐 *{{2}}*\n\nEste código expira em {{3}} minutos. Não compartilhe com ninguém.',
      footerText: 'Se você não solicitou este código, ignore esta mensagem.',
      buttons: [],
      variaveisExemplo: {
        '1': 'Usuário',
        '2': '123456',
        '3': '5'
      }
    }
  ];

  // Função para transformar template da API em formato compatível
  const transformarTemplateBiblioteca = (template) => {
    // Se o template já tem os campos no nível raiz (formato da biblioteca), usar diretamente
    if (template.nome && template.conteudo !== undefined) {
      return {
        id: template._id || template.id,
        nome: template.nome || template.name || 'Template sem nome',
        categoria: template.categoria || template.category || 'UTILITY',
        descricao: template.descricao || template.description || '',
        conteudo: template.conteudo || '',
        headerType: template.headerType || 'none',
        headerText: template.headerText || '',
        headerMedia: template.headerMedia || '',
        footerText: template.footerText || '',
        buttons: template.buttons || [],
        variaveisExemplo: template.variaveisExemplo || {},
        language: template.language || template.lingua || 'pt_BR',
        status: template.status || 'ACTIVE',
        tags: template.tags || []
      };
    }

    // Caso contrário, tentar extrair dos components (formato padrão da API)
    const components = template.components || [];
    const bodyComponent = components.find(c =>
      (c.type === 'body' || c.type === 'BODY') && c.text
    );
    const headerComponent = components.find(c =>
      (c.type === 'header' || c.type === 'HEADER')
    );
    const footerComponent = components.find(c =>
      (c.type === 'footer' || c.type === 'FOOTER') && c.text
    );
    const buttonsComponent = components.find(c =>
      (c.type === 'buttons' || c.type === 'BUTTONS') && c.buttons
    );

    let headerType = 'none';
    let headerText = '';

    if (headerComponent) {
      const format = headerComponent.format?.toUpperCase() || '';
      if (format === 'TEXT' && headerComponent.text) {
        headerType = 'text';
        headerText = headerComponent.text;
      } else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(format)) {
        headerType = format.toLowerCase();
        headerText = headerComponent.text || '';
      }
    }

    return {
      id: template._id || template.id,
      nome: template.name || template.nome || 'Template sem nome',
      categoria: template.category || template.categoria || 'UTILITY',
      descricao: template.description || template.descricao || '',
      conteudo: bodyComponent?.text || '',
      headerType: headerType,
      headerText: headerText,
      headerMedia: headerComponent?.text || '',
      footerText: footerComponent?.text || '',
      buttons: buttonsComponent?.buttons || [],
      variaveisExemplo: {},
      language: template.language || template.lingua || 'pt_BR',
      status: template.status || 'ACTIVE',
      tags: template.tags || []
    };
  };

  // Função para aplicar um modelo pré-pronto aos campos
  const aplicarModeloPrePronto = (modelo) => {
    setNome(modelo.nome);
    setCategoria(modelo.categoria);
    setLingua('pt_BR');
    setConteudo(modelo.conteudo || '');
    setDescricao(modelo.descricao || '');
    setHeaderType(modelo.headerType || 'none');
    setHeaderText(modelo.headerText || '');
    setHeaderMedia(modelo.headerMedia || '');
    setFooterText(modelo.footerText || '');
    setButtons(modelo.buttons || []);
    setTags('');
    setCanalId('');
    setSessao('');
    setParameterFormat('positional');
    setTimeToLive(86400);
    setError(null);

    // Extrair e preencher variáveis do template
    const variaveis = extrairVariaveisDoTexto(modelo.conteudo || '');
    const variaveisComExemplo = {};
    Object.keys(variaveis).forEach(key => {
      variaveisComExemplo[key] = modelo.variaveisExemplo?.[key] || '';
    });
    setVariaveisTemplate(variaveisComExemplo);
    setErrosValidacao({});
    setVariaveisBotoes({});
    setMostrarBiblioteca(false); // Fechar biblioteca e mostrar formulário
  };

  // Função helper para obter o nome do canal pelo cliente_id
  const obterNomeCanal = (canalId) => {
    if (!canalId) return '-';
    const canal = canais.find(c => c.canalId === canalId);
    return canal?.nome || '-';
  };

  const buscarCanais = async () => {
    try {
      const clienteId = cliente?._id || user?.clienteId;
      if (!clienteId) return;

      const response = await actionListaCanaisPorCliente(clienteId);
      const todosCanais = response.data?.data || [];
      // Filtrar apenas canais WhatsApp Business
      const canaisWhatsAppBusiness = todosCanais.filter(canal => canal.platform === 'whatsapp_business');
      setCanais(canaisWhatsAppBusiness);

      // Buscar contagem de logs não vistos
      v1_actionWboTemplatesCategoryLogsNaoVistos(clienteId)
        .then(res => setLogsNaoVistos(res.data?.data?.count || 0))
        .catch(() => {});

      // Se houver pelo menos 1 canal WhatsApp Business, definir o primeiro como padrão
      if (canaisWhatsAppBusiness.length > 0) {
        const primeiroCanal = canaisWhatsAppBusiness[0];
        const canalId = primeiroCanal.cliente_id;
        if (canalId) {
          setClienteIdTemplate(canalId);
          setCanalFiltro(canalId);
        }
      }
    } catch (error) {
      console.error('Erro ao buscar canais:', error);
    }
  };

  // Função para extrair variáveis do texto
  const extrairVariaveisDoTexto = (texto) => {
    const variaveis = {};
    if (!texto) return variaveis;

    // Buscar padrões como {{1}}, {{2}}, etc.
    const matches = texto.match(/\{\{(\d+)\}\}/g);
    if (matches) {
      matches.forEach((match) => {
        const numero = match.replace(/\{\{|\}\}/g, '');
        if (!variaveis[numero]) {
          variaveis[numero] = '';
        }
      });
    }

    return variaveis;
  };

  // Função para extrair variáveis de uma URL de botão
  const extrairVariaveisDaBotaoUrl = (url) => {
    if (!url) return [];
    const matches = url.match(/\{\{(\d+)\}\}/g);
    if (!matches) return [];
    return [...new Set(matches.map(m => m.replace(/\{\{|\}\}/g, '')))].sort((a, b) => parseInt(a) - parseInt(b));
  };

  // Função para validar formato de telefone (formato E.164: +[código do país][número])
  const validarTelefone = (telefone) => {
    if (!telefone || !telefone.trim()) {
      return { valido: false, mensagem: 'Número de telefone é obrigatório' };
    }

    // Remove espaços e caracteres especiais para validação
    const telefoneLimpo = telefone.trim();

    // Deve começar com +
    if (!telefoneLimpo.startsWith('+')) {
      return { valido: false, mensagem: 'O número deve começar com + seguido do código do país (ex: +5511999999999)' };
    }

    // Deve conter apenas números após o +
    const numeroSemPlus = telefoneLimpo.substring(1);
    if (!/^\d+$/.test(numeroSemPlus)) {
      return { valido: false, mensagem: 'O número deve conter apenas dígitos após o + (ex: +5511999999999)' };
    }

    // Deve ter pelo menos 10 dígitos (código do país + número)
    if (numeroSemPlus.length < 10) {
      return { valido: false, mensagem: 'O número deve ter pelo menos 10 dígitos após o +' };
    }

    // Deve ter no máximo 15 dígitos (padrão E.164)
    if (numeroSemPlus.length > 15) {
      return { valido: false, mensagem: 'O número não pode ter mais de 15 dígitos após o +' };
    }

    return { valido: true, mensagem: '' };
  };

  // Buscar canais ao montar o componente
  useEffect(() => {
    buscarCanais();
  }, []);

  // Buscar templates quando clienteIdTemplate mudar
  useEffect(() => {
    if (clienteIdTemplate) {
      buscarTemplates();
    }
  }, [clienteIdTemplate]);

  // Buscar templates da biblioteca quando a biblioteca for aberta ou filtros mudarem
  useEffect(() => {
    if (mostrarBiblioteca && !idEdit) {
      // Debounce na pesquisa
      const timeoutId = setTimeout(() => {
        buscarTemplatesBiblioteca();
      }, pesquisaBiblioteca ? 500 : 0);

      return () => clearTimeout(timeoutId);
    }
  }, [mostrarBiblioteca, categoriaFiltro, pesquisaBiblioteca]);

  // Detectar variáveis automaticamente quando o conteúdo muda
  useEffect(() => {
    const variaveis = extrairVariaveisDoTexto(conteudo);
    setVariaveisTemplate(variaveis);
    setErrosValidacao({});
  }, [conteudo]);

  // Função para atualizar uma variável
  const handleAtualizarVariavel = (variavel, valor) => {
    setVariaveisTemplate(prev => ({
      ...prev,
      [variavel]: valor
    }));

    // Remover erro ao preencher
    if (String(valor).trim()) {
      setErrosValidacao(prev => {
        const novos = { ...prev };
        delete novos[variavel];
        return novos;
      });
    }
  };



  // Função para inserir variável no texto na posição do cursor
  const inserirVariavel = (numero) => {
    const textarea = textareaRef.current;
    if (!textarea || idEdit) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const textoAntes = conteudo.substring(0, start);
    const textoDepois = conteudo.substring(end);
    const novaVariavel = `{{${numero}}}`;
    const novoTexto = textoAntes + novaVariavel + textoDepois;

    setConteudo(novoTexto);

    // Reposicionar cursor após a variável inserida
    setTimeout(() => {
      textarea.focus();
      const novaPosicao = start + novaVariavel.length;
      textarea.setSelectionRange(novaPosicao, novaPosicao);
    }, 0);
  };

  // Função para adicionar próxima variável disponível
  const adicionarProximaVariavel = () => {
    const variaveisExistentes = Object.keys(variaveisTemplate);
    let proximoNumero = 1;

    if (variaveisExistentes.length > 0) {
      const numeros = variaveisExistentes.map(v => parseInt(v)).sort((a, b) => b - a);
      proximoNumero = numeros[0] + 1;
    }

    inserirVariavel(proximoNumero);
  };

  // Função para aplicar formatação ao texto
  const aplicarFormatacao = (tipo) => {
    const textarea = textareaRef.current;
    if (!textarea || idEdit) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const textoSelecionado = conteudo.substring(start, end);

    let textoFormatado = '';
    let textoAntes = '';
    let textoDepois = '';

    switch (tipo) {
      case 'bold':
        textoFormatado = textoSelecionado ? `*${textoSelecionado}*` : '**';
        break;
      case 'italic':
        textoFormatado = textoSelecionado ? `_${textoSelecionado}_` : '__';
        break;
      case 'strikethrough':
        textoFormatado = textoSelecionado ? `~${textoSelecionado}~` : '~~';
        break;
      case 'code':
        textoFormatado = textoSelecionado ? `\`${textoSelecionado}\`` : '``';
        break;
      default:
        return;
    }

    textoAntes = conteudo.substring(0, start);
    textoDepois = conteudo.substring(end);
    const novoTexto = textoAntes + textoFormatado + textoDepois;

    setConteudo(novoTexto);

    // Reposicionar cursor
    setTimeout(() => {
      textarea.focus();
      let novaPosicao;
      if (textoSelecionado) {
        novaPosicao = start + textoFormatado.length;
      } else {
        novaPosicao = start + (textoFormatado.length / 2);
      }
      textarea.setSelectionRange(novaPosicao, novaPosicao);
    }, 0);
  };

  const buscarTemplates = async () => {
    try {
      setLoading(true);
      const res = await v1_actionWboTemplates(clienteIdTemplate);
      const templates = res.data?.data?.templates || [];
      setLista(templates);
    } catch (error) {
      console.error('Erro ao buscar templates:', error);
      setLista([]);
    } finally {
      setLoading(false);
    }
  };

  const buscarTemplatesBiblioteca = async () => {
    try {
      setLoadingBiblioteca(true);
      const params = {
        page: 1,
        limit: 100,
        ...(categoriaFiltro && categoriaFiltro !== 'all' && { category: categoriaFiltro }),
        ...(pesquisaBiblioteca && { search: pesquisaBiblioteca })
      };

      const res = await v1_actionLibraryTemplates(params);

      if (res.data?.status === 'success' && res.data?.data?.templates) {
        const templates = Array.isArray(res.data.data.templates) ? res.data.data.templates : [];
        setTemplatesBiblioteca(templates);
        setPaginacaoBiblioteca(res.data.data.pagination || null);
      } else {
        // Se não houver templates da API, usar modelos pré-prontos
        setTemplatesBiblioteca([]);
        setPaginacaoBiblioteca(null);
      }
    } catch (error) {
      console.error('Erro ao buscar templates da biblioteca:', error);
      // Em caso de erro, usar modelos pré-prontos como fallback
      setTemplatesBiblioteca([]);
      setPaginacaoBiblioteca(null);
    } finally {
      setLoadingBiblioteca(false);
    }
  };

  const handleNovo = () => {
    setIdEdit(null);
    setNome('');
    setCategoria('');
    setLingua('pt_BR');
    setConteudo('');
    setDescricao('');
    setTags('');
    setCanalId('');
    setSessao('');
    setParameterFormat('positional');
    setHeaderType('none');
    setHeaderText('');
    setHeaderMedia('');
    setHeaderMediaFileName('');
    setHeaderMediaPreview('');
    setHeaderMediaFile(null);
    setHeaderMediaFilenameOriginal('');
    setHeaderMediaUploading(false);
    setFooterText('');
    setButtons([]);
    setTimeToLive(86400);
    setError(null);
    setVariaveisTemplate({});
    setErrosValidacao({});
    setVariaveisBotoes({});
    setMostrarBiblioteca(false);
    setPesquisaBiblioteca('');
    setCategoriaFiltro('all');
    setOpenDrawer(true);
    setIsEditing(false); // Reset editing mode
  };

  // Seleção de arquivo para header de mídia (apenas validação + preview local)
  const handleHeaderFileUpload = (file) => {
    if (!file) return;

    // Validar tipo de arquivo
    const allowedTypes = {
      image: ['image/jpeg', 'image/png'],
      video: ['video/mp4'],
      document: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    };

    const allowed = allowedTypes[headerType] || [];
    if (allowed.length > 0 && !allowed.includes(file.type)) {
      setError(`Tipo de arquivo não suportado. Tipos aceitos: ${allowed.map(t => t.split('/')[1]).join(', ')}`);
      return;
    }

    // Validar tamanho por tipo (imagem 5MB, vídeo 16MB, documento 100MB)
    const maxSizes = { image: 5 * 1024 * 1024, video: 16 * 1024 * 1024, document: 100 * 1024 * 1024 };
    const maxSize = maxSizes[headerType] || 16 * 1024 * 1024;
    if (file.size > maxSize) {
      setError(`Arquivo muito grande. Tamanho máximo: ${maxSize / (1024 * 1024)}MB`);
      return;
    }

    // Gerar preview local imediato e guardar arquivo para envio posterior
    const localPreviewUrl = URL.createObjectURL(file);
    setHeaderMediaPreview(localPreviewUrl);
    setHeaderMediaFileName(file.name);
    setHeaderMediaFile(file);
    setHeaderMedia('file-selected'); // marcador para validação
    setError(null);
  };

  const handleSalvar = async () => {
    try {
      setLoading(true);
      setError(null);

      // Validar campos obrigatórios
      if (!nome.trim()) {
        setError('Por favor, preencha o nome do template.');
        setLoading(false);
        return;
      }

      if (!categoria) {
        setError('Por favor, selecione a categoria do template.');
        setLoading(false);
        return;
      }

      if (!clienteIdTemplate) {
        setError('Por favor, selecione o canal do template.');
        setLoading(false);
        return;
      }

      // Validar mídia do header
      if (['image', 'video', 'document'].includes(headerType) && !headerMedia && !headerMediaPreview) {
        setError(`Por favor, faça upload de um arquivo para o header do tipo ${headerType === 'image' ? 'imagem' : headerType === 'video' ? 'vídeo' : 'documento'}.`);
        setLoading(false);
        return;
      }

      // Validar se todas as variáveis foram preenchidas
      const variaveisEncontradas = extrairVariaveisDoTexto(conteudo);
      const variaveisOrdenadas = Object.keys(variaveisEncontradas).sort((a, b) => parseInt(a) - parseInt(b));
      const variaveisNaoPreenchidas = [];

      variaveisOrdenadas.forEach((variavel) => {
        const valor = variaveisTemplate[variavel] || '';
        if (!String(valor).trim()) {
          variaveisNaoPreenchidas.push(variavel);
        }
      });

      if (variaveisNaoPreenchidas.length > 0) {
        setError(`Por favor, preencha todas as amostras de variáveis antes de salvar. Variáveis faltando: ${variaveisNaoPreenchidas.map(v => `{{${v}}}`).join(', ')}`);
        setLoading(false);

        // Marcar campos com erro
        const erros = {};
        variaveisNaoPreenchidas.forEach((variavel) => {
          erros[variavel] = 'Este campo é obrigatório';
        });
        setErrosValidacao(erros);

        // Scroll para o formulário de amostras
        setTimeout(() => {
          const formularioAmostras = document.querySelector('[data-formulario-amostras]');
          if (formularioAmostras) {
            formularioAmostras.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);

        return;
      }

      // Validar botões
      if (buttons.length > 0) {
        for (let i = 0; i < buttons.length; i++) {
          const button = buttons[i];

          if (!button.text || !button.text.trim()) {
            setError(`Por favor, preencha o texto do botão no índice ${i + 1}.`);
            setLoading(false);
            return;
          }

          if (button.type === 'URL' && (!button.url || !button.url.trim())) {
            setError(`Por favor, preencha a URL do botão no índice ${i + 1}.`);
            setLoading(false);
            return;
          }

          if (button.type === 'PHONE_NUMBER') {
            if (!button.phone_number || !button.phone_number.trim()) {
              setError(`Por favor, preencha o número de telefone do botão no índice ${i + 1}.`);
              setLoading(false);
              return;
            }

            // Validar formato do telefone
            const validacaoTelefone = validarTelefone(button.phone_number);
            if (!validacaoTelefone.valido) {
              setError(`Número de telefone inválido no botão ${i + 1}: ${validacaoTelefone.mensagem}`);
              setLoading(false);
              return;
            }
          }

          // Validar amostras de variáveis em URLs de botões
          if (button.type === 'URL' && button.url) {
            const varsUrl = extrairVariaveisDaBotaoUrl(button.url);
            if (varsUrl.length > 0) {
              const exemplosBotao = variaveisBotoes[i] || {};
              const varsFaltando = varsUrl.filter(v => !String(exemplosBotao[v] || '').trim());
              if (varsFaltando.length > 0) {
                setError(`Por favor, preencha as amostras de variáveis da URL do botão ${i + 1}. Variáveis faltando: ${varsFaltando.map(v => `{{${v}}}`).join(', ')}`);
                setLoading(false);
                return;
              }
            }
          }
        }
      }

      // Construir componentes do template
      const templateComponents = [];

      // Header
      if (headerType !== 'none') {
        const headerComponent = { type: "HEADER" };
        if (headerType === 'text') {
          headerComponent.format = "TEXT";
          headerComponent.text = headerText;
        } else if (['image', 'video', 'document'].includes(headerType)) {
          headerComponent.format = headerType.toUpperCase();

          // Upload do arquivo para Meta e obter header_handle
          if (headerMediaFile) {
            try {
              setError(null);
              const formData = new FormData();
              formData.append('file', headerMediaFile);
              const uploadRes = await v1_actionWboUploadMidiaTemplate(clienteIdTemplate, formData);
              if (uploadRes.data?.status === 'success' && uploadRes.data?.data?.handle) {
                headerComponent.example = {
                  header_handle: [uploadRes.data.data.handle]
                };
                // Salvar URL pública do S3 para uso no envio de mensagens
                if (uploadRes.data.data.mediaUrl) {
                  headerComponent.mediaUrl = uploadRes.data.data.mediaUrl;
                }
                if (uploadRes.data.data.originalFilename) {
                  headerComponent.mediaFilename = uploadRes.data.data.originalFilename;
                }
              } else {
                setError('Erro ao fazer upload da mídia para o Meta.');
                setLoading(false);
                return;
              }
            } catch (uploadErr) {
              console.error('Erro no upload de mídia:', uploadErr);
              setError(uploadErr.response?.data?.details || uploadErr.response?.data?.message || 'Erro ao fazer upload da mídia para o Meta.');
              setLoading(false);
              return;
            }
          } else if (headerMedia && headerMedia !== 'file-selected' && headerMedia !== 'media-registered') {
            // Modo link público ou edição sem trocar mídia — envia a URL direto
            headerComponent.example = {
              header_url: [headerMedia]
            };
            // Se é uma URL S3 existente (edição sem trocar mídia), preservar mediaUrl e mediaFilename
            if (headerMedia.includes('s3.') && headerMedia.includes('amazonaws.com')) {
              headerComponent.mediaUrl = headerMedia;
              if (headerMediaFilenameOriginal) {
                headerComponent.mediaFilename = headerMediaFilenameOriginal;
              }
            }
          }
        }
        templateComponents.push(headerComponent);
      }

      // Body
      if (conteudo) {
        const bodyComponent = { type: "BODY", text: conteudo };

        // Adicionar exemplo de variáveis se houver variáveis no corpo
        if (Object.keys(variaveisTemplate).length > 0) {
          const variaveisOrdenadas = Object.keys(variaveisTemplate).sort((a, b) => parseInt(a) - parseInt(b));
          const valoresExemplo = variaveisOrdenadas.map((variavel) => {
            const valor = variaveisTemplate[variavel] || '';
            return valor.trim();
          });

          // Só adiciona o example se todas as variáveis foram preenchidas
          if (valoresExemplo.every(valor => valor && valor.trim())) {
            bodyComponent.example = {
              body_text: [valoresExemplo]
            };
          }
        }

        templateComponents.push(bodyComponent);
      }

      // Footer
      if (footerText) {
        templateComponents.push({ type: "FOOTER", text: footerText });
      }

      // Buttons
      if (buttons.length > 0) {
        templateComponents.push({
          type: "BUTTONS",
          buttons: buttons.map((btn, btnIndex) => {
            const buttonObj = {
              type: btn.type,
              text: btn.text
            };

            // Adicionar campos específicos por tipo
            if (btn.type === 'URL' && btn.url) {
              buttonObj.url = btn.url;

              // Adicionar exemplo de variáveis da URL se houver
              // Meta espera a URL completa com variáveis substituídas: example: ["https://ex.com/12345"]
              const varsUrl = extrairVariaveisDaBotaoUrl(btn.url);
              if (varsUrl.length > 0) {
                const exemplosBotao = variaveisBotoes[btnIndex] || {};
                const todosPreenchidos = varsUrl.every(v => String(exemplosBotao[v] || '').trim());
                if (todosPreenchidos) {
                  let urlExemplo = btn.url;
                  varsUrl.forEach(v => {
                    urlExemplo = urlExemplo.replace(`{{${v}}}`, String(exemplosBotao[v]).trim());
                  });
                  buttonObj.example = [urlExemplo];
                }
              }
            }

            if (btn.type === 'PHONE_NUMBER' && btn.phone_number) {
              // Normalizar número de telefone: remover espaços e caracteres especiais, manter formato E.164
              const telefoneNormalizado = btn.phone_number.trim().replace(/[\s\-\(\)]/g, '');
              buttonObj.phone_number = telefoneNormalizado;
            }

            return buttonObj;
          })
        });
      }

      const payload = {
        name: nome,
        category: categoria,
        language: lingua,
        parameter_format: parameterFormat,
        components: templateComponents,
        description: descricao,
        userId: user?.id,
        tags: tags ? tags.split(',').map(tag => tag.trim()) : [],
        cliente_id: clienteIdTemplate,
        sessao: sessao,
        time_to_live: timeToLive
      };



      let response;
      if (idEdit && isEditing) {
        // Edit existing template
        // Encontrar o objeto template original para pegar o ID correto se necessário
        // Mas idEdit já deve ser o ID.
        response = await v1_actionWboEditarTemplate(clienteIdTemplate, idEdit, payload);
      } else {
        // Create new template
        response = await v1_actionWboCriarTemplate(clienteIdTemplate, payload);
      }

      // Verificar se a resposta contém erro
      if (response?.data?.status === 'error') {
        setError(response.data.message || 'Erro ao salvar template');
        return;
      }

      await buscarTemplates();
      setOpenDrawer(false);
    } catch (error) {
      console.error('Erro ao salvar template:', error);

      // Tentar extrair mensagem de erro da resposta
      let errorMessage = 'Erro ao salvar template';

      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDeletar = async (templateId, e) => {
    if (e) e.stopPropagation();

    // Confirmação simples
    if (!window.confirm('Tem certeza que deseja excluir este template? Esta ação não pode ser desfeita.')) {
      return;
    }

    try {
      setLoading(true);
      await v1_actionWboDeletarTemplate(clienteIdTemplate, templateId);

      // Se estiver com o drawer aberto no template que foi deletado, fechar
      if (idEdit === templateId) {
        setOpenDrawer(false);
      }

      await buscarTemplates();
    } catch (error) {
      console.error('Erro ao deletar template:', error);
      alert('Erro ao deletar template: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleVisualizar = async (template) => {
    const editId = template._id || template.id;
    setIdEdit(editId);
    setIsEditing(false);

    // Se template tem header de mídia, buscar dados completos (com URL da mídia da Meta)
    const hasMediaHeader = (template.components || []).some(c =>
      (c.type === 'HEADER' || c.type === 'header') &&
      ['IMAGE', 'VIDEO', 'DOCUMENT'].includes((c.format || '').toUpperCase())
    );

    if (hasMediaHeader && clienteIdTemplate) {
      try {
        const res = await v1_actionWboObterTemplate(clienteIdTemplate, editId);
        if (res.data?.status === 'success' && res.data?.data) {
          template = res.data.data;
        }
      } catch (err) {
        console.log('Não foi possível buscar URL da mídia:', err.message);
      }
    }

    // Dados básicos
    setNome(template.name || '');
    setCategoria(template.category || '');
    setLingua(template.language || 'pt_BR');
    setDescricao(template.description || '');
    setTags(template.tags?.join(', ') || '');
    setCanalId(template.canalId || '');
    setSessao(template.sessao || '');

    // Componentes do template
    const components = template.components || [];

    // Header - Buscar tanto em uppercase quanto lowercase
    const headerComponent = components.find(c =>
      c.type === 'HEADER' || c.type === 'header'
    );
    if (headerComponent) {
      const fmt = (headerComponent.format || '').toUpperCase();
      if (fmt === 'TEXT') {
        setHeaderType('text');
        setHeaderText(headerComponent.text || '');
      } else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(fmt)) {
        setHeaderType(fmt.toLowerCase());
        // Prioridade: mediaUrl (S3, salvo no banco) > header_url (Meta API) > marcador
        const headerUrl = headerComponent.mediaUrl || headerComponent.example?.header_url?.[0] || '';
        setHeaderMedia(headerUrl || 'media-registered');
        setHeaderMediaFilenameOriginal(headerComponent.mediaFilename || '');
      }
    } else {
      setHeaderType('none');
      setHeaderText('');
      setHeaderMedia('');
    }

    // Body - Buscar tanto em uppercase quanto lowercase
    const bodyComponent = components.find(c =>
      c.type === 'BODY' || c.type === 'body'
    );
    setConteudo(bodyComponent?.text || '');

    // Footer - Buscar tanto em uppercase quanto lowercase
    const footerComponent = components.find(c =>
      c.type === 'FOOTER' || c.type === 'footer'
    );
    setFooterText(footerComponent?.text || '');

    // Buttons - Buscar tanto em uppercase quanto lowercase
    const buttonsComponent = components.find(c =>
      c.type === 'BUTTONS' || c.type === 'buttons'
    );
    if (buttonsComponent && buttonsComponent.buttons) {
      setButtons(buttonsComponent.buttons.map(btn => ({
        type: btn.type,
        text: btn.text,
        url: btn.url,
        phone_number: btn.phone_number
      })));

      // Carregar amostras de variáveis dos botões
      const novasVariaveisBotoes = {};
      buttonsComponent.buttons.forEach((btn, index) => {
        if (btn.type === 'URL' && btn.url && btn.example) {
          const varsUrl = extrairVariaveisDaBotaoUrl(btn.url);
          if (varsUrl.length > 0) {
            novasVariaveisBotoes[index] = {};
            varsUrl.forEach((v, i) => {
              novasVariaveisBotoes[index][v] = btn.example[i] || '';
            });
          }
        }
      });
      setVariaveisBotoes(novasVariaveisBotoes);
    } else {
      setButtons([]);
      setVariaveisBotoes({});
    }

    // Outros campos
    setParameterFormat(template.parameter_format || 'positional');
    setTimeToLive(template.time_to_live || 86400);

    setError(null);
    setOpenDrawer(true);
  };


  // Computed stats
  const approvedCount = lista.filter(t => t.status === 'APPROVED').length;
  const pendingCount = lista.filter(t => t.status === 'PENDING').length;
  const rejectedCount = lista.filter(t => t.status === 'REJECTED').length;

  const listaFiltrada = lista.filter(template => {
    if (pesquisa && pesquisa.trim()) {
      const pesquisaLower = pesquisa.toLowerCase();
      const matchName = template.name?.toLowerCase().includes(pesquisaLower);
      const matchTemplateName = template.templateName?.toLowerCase().includes(pesquisaLower);
      const matchCategory = template.category?.toLowerCase().includes(pesquisaLower);
      if (!matchName && !matchTemplateName && !matchCategory) return false;
    }
    return true;
  });

  return (
    <>
      <div className={TEMPLATES_WHATSAPP_DESIGN.page.container}>
        {/* Header */}
        <div className={TEMPLATES_WHATSAPP_DESIGN.page.header.container}>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center border border-green-100">
              <Iconify icon="ic:round-whatsapp" width={28} className="text-green-600" />
            </div>
            <div>
              <h1 className={TEMPLATES_WHATSAPP_DESIGN.page.header.title}>Templates WhatsApp</h1>
              <p className={TEMPLATES_WHATSAPP_DESIGN.page.header.subtitle}>
                Gerencie templates aprovados do WhatsApp Business Oficial.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2.5">
            <Button
              variant="outline"
              onClick={() => navigate('/dashboard/configuracoes/templates-category-logs')}
              className="relative border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-xl px-3.5 py-2.5 h-auto text-sm font-medium transition-all"
            >
              <Iconify icon="eva:file-text-outline" width={17} className="mr-1.5" />
              <span className="hidden sm:inline">Logs</span>
              {logsNaoVistos > 0 && (
                <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-red-500 text-white text-[10px] font-bold rounded-full px-1">
                  {logsNaoVistos > 99 ? '99+' : logsNaoVistos}
                </span>
              )}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setIdEdit(null);
                setIsEditing(false);
                setNome('');
                setCategoria('');
                setLingua('pt_BR');
                setConteudo('');
                setDescricao('');
                setTags('');
                setCanalId('');
                setSessao('');
                setParameterFormat('positional');
                setHeaderType('none');
                setHeaderText('');
                setHeaderMedia('');
                setHeaderMediaFileName('');
                setHeaderMediaPreview('');
                setHeaderMediaFile(null);
                setHeaderMediaFilenameOriginal('');
                setFooterText('');
                setButtons([]);
                setTimeToLive(86400);
                setError(null);
                setVariaveisTemplate({});
                setErrosValidacao({});
                setMostrarBiblioteca(true);
                setPesquisaBiblioteca('');
                setCategoriaFiltro('all');
                setOpenDrawer(true);
              }}
              className="border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-xl px-3.5 py-2.5 h-auto text-sm font-medium transition-all"
            >
              <Iconify icon="eva:book-outline" width={17} className="mr-1.5" />
              <span className="hidden sm:inline">Biblioteca</span>
            </Button>
            <button
              onClick={handleNovo}
              className={TEMPLATES_WHATSAPP_DESIGN.page.actionButton}
            >
              <Iconify icon="eva:plus-outline" width={18} />
              <span>Novo Template</span>
            </button>
          </div>
        </div>

        {/* Alert */}
        <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
          <Iconify icon="eva:alert-triangle-outline" width={20} className="text-amber-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-800">
            Os templates do WhatsApp estão sujeitos a alterações, reclassificações ou rejeições pela Meta a qualquer momento, mesmo após a aprovação inicial.
          </p>
        </div>

        {/* Stats Cards */}
        <div className={TEMPLATES_WHATSAPP_DESIGN.stats.grid}>
          <div className={TEMPLATES_WHATSAPP_DESIGN.stats.card}>
            <div className={`${TEMPLATES_WHATSAPP_DESIGN.stats.iconBox} bg-violet-50`}>
              <Iconify icon="eva:layers-outline" width={20} className="text-violet-600" />
            </div>
            <div>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.value}>{lista.length}</p>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.label}>Total</p>
            </div>
          </div>
          <div className={TEMPLATES_WHATSAPP_DESIGN.stats.card}>
            <div className={`${TEMPLATES_WHATSAPP_DESIGN.stats.iconBox} bg-green-50`}>
              <Iconify icon="eva:checkmark-circle-2-outline" width={20} className="text-green-600" />
            </div>
            <div>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.value}>{approvedCount}</p>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.label}>Aprovados</p>
            </div>
          </div>
          <div className={TEMPLATES_WHATSAPP_DESIGN.stats.card}>
            <div className={`${TEMPLATES_WHATSAPP_DESIGN.stats.iconBox} bg-amber-50`}>
              <Iconify icon="eva:clock-outline" width={20} className="text-amber-500" />
            </div>
            <div>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.value}>{pendingCount}</p>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.label}>Pendentes</p>
            </div>
          </div>
          <div className={TEMPLATES_WHATSAPP_DESIGN.stats.card}>
            <div className={`${TEMPLATES_WHATSAPP_DESIGN.stats.iconBox} bg-red-50`}>
              <Iconify icon="eva:close-circle-outline" width={20} className="text-red-500" />
            </div>
            <div>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.value}>{rejectedCount}</p>
              <p className={TEMPLATES_WHATSAPP_DESIGN.stats.label}>Rejeitados</p>
            </div>
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <div className="w-full">
            <div className="h-1 bg-gray-100 rounded-full overflow-hidden">
              <div className="h-full bg-[#7C3AED] rounded-full animate-[pulse_1.5s_ease-in-out_infinite]" style={{ width: '40%' }} />
            </div>
          </div>
        )}

        {/* Filters */}
        <div className={TEMPLATES_WHATSAPP_DESIGN.filters.grid}>
          <div>
            <Label className={TEMPLATES_WHATSAPP_DESIGN.filters.label}>Canal</Label>
            <Select
              value={canalFiltro}
              onValueChange={(value) => {
                setCanalFiltro(value);
                if (value !== 'all') {
                  setClienteIdTemplate(value);
                }
              }}
            >
              <SelectTrigger className={TEMPLATES_WHATSAPP_DESIGN.filters.select}>
                <SelectValue placeholder="Todos os canais" />
              </SelectTrigger>
              <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                <SelectItem value="all">Todos os canais</SelectItem>
                {canais.map((canal) => (
                  <SelectItem key={canal.cliente_id} value={canal.cliente_id}>
                    {canal.nome}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className={TEMPLATES_WHATSAPP_DESIGN.filters.label}>Categoria</Label>
            <Select value={categoriaFiltro} onValueChange={setCategoriaFiltro}>
              <SelectTrigger className={TEMPLATES_WHATSAPP_DESIGN.filters.select}>
                <SelectValue placeholder="Todas as categorias" />
              </SelectTrigger>
              <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                <SelectItem value="all">Todas as categorias</SelectItem>
                <SelectItem value="UTILITY">Utilidade</SelectItem>
                <SelectItem value="MARKETING">Marketing</SelectItem>
                <SelectItem value="AUTHENTICATION">Autenticação</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className={TEMPLATES_WHATSAPP_DESIGN.filters.label}>Pesquisar</Label>
            <div className="relative">
              <Iconify icon="eva:search-outline" width={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <Input
                placeholder="Buscar por nome ou categoria..."
                value={pesquisa}
                onChange={(e) => setPesquisa(e.target.value)}
                className={TEMPLATES_WHATSAPP_DESIGN.filters.searchInput}
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <GenericTable
          headLabels={[
            { id: 'name', label: 'Template', className: 'flex-1 pl-4' },
            { id: 'category', label: 'Categoria', className: 'w-32' },
            { id: 'language', label: 'Idioma', className: 'w-24' },
            { id: 'channel', label: 'Canal', className: 'w-44' },
            { id: 'status', label: 'Status', className: 'w-32 text-center' },
            { id: 'actions', label: '', className: 'w-24 text-right pr-4' },
          ]}
        >
          {listaFiltrada.map((template) => (
            <div
              key={template.id}
              className={`${GENERIC_TABLE_DESIGN.row.container} cursor-pointer`}
              onClick={() => handleVisualizar(template)}
            >
              {/* Name */}
              <div className="flex-1 pl-4 min-w-[200px] pr-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-green-50 flex items-center justify-center flex-shrink-0">
                    <Iconify icon="ic:round-whatsapp" width={18} className="text-green-600" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-gray-900 truncate">{template.templateName || template.name}</h3>
                    <p className="text-[11px] text-gray-400 font-mono truncate">{template.templateId || template.name}</p>
                  </div>
                </div>
              </div>

              {/* Category */}
              <div className="w-32">
                <Badge variant="outline" className={`text-xs font-medium ${
                  template.category === 'MARKETING' ? 'text-blue-600 border-blue-200 bg-blue-50' :
                  template.category === 'AUTHENTICATION' ? 'text-orange-600 border-orange-200 bg-orange-50' :
                  'text-gray-600 border-gray-200 bg-gray-50'
                }`}>
                  {transformCategoryTemplateWhatsApp(template.category)}
                </Badge>
              </div>

              {/* Language */}
              <div className="w-24">
                <span className="text-[11px] text-gray-500 bg-gray-50 border border-gray-100 rounded-md px-2 py-0.5">
                  {template.language || 'pt_BR'}
                </span>
              </div>

              {/* Channel */}
              <div className="w-44 text-sm text-gray-600 truncate">
                {template?.cliente_id?.nome || '-'}
              </div>

              {/* Status */}
              <div className="w-32 flex justify-center">
                <Badge variant="outline" className={`text-xs font-medium flex items-center gap-1.5 ${
                  template.status === 'APPROVED' ? 'bg-green-50 text-green-700 border-green-200' :
                  template.status === 'REJECTED' ? 'bg-red-50 text-red-700 border-red-200' :
                  template.status === 'PENDING' ? 'bg-amber-50 text-amber-700 border-amber-200' :
                  'bg-gray-50 text-gray-700 border-gray-200'
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full ${
                    template.status === 'APPROVED' ? 'bg-green-500' :
                    template.status === 'REJECTED' ? 'bg-red-500' :
                    template.status === 'PENDING' ? 'bg-amber-500' :
                    'bg-gray-400'
                  }`} />
                  {transformStatusTemplateWhatsApp(template.status)}
                </Badge>
              </div>

              {/* Actions */}
              <div className="w-24 flex justify-end pr-4 gap-1" onClick={(e) => e.stopPropagation()}>
                <button
                  onClick={() => handleVisualizar(template)}
                  className="p-1.5 hover:bg-violet-50 text-gray-400 hover:text-violet-600 rounded-lg transition-colors"
                  title="Visualizar"
                >
                  <Iconify icon="eva:eye-outline" width={18} />
                </button>
                <button
                  onClick={(e) => handleDeletar(template._id || template.id, e)}
                  title="Deletar"
                  className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-lg transition-colors"
                >
                  <Iconify icon="eva:trash-2-outline" width={18} />
                </button>
              </div>
            </div>
          ))}

          {/* Empty state */}
          {listaFiltrada.length === 0 && !loading && (
            <div className="flex flex-col items-center justify-center py-16 px-6">
              <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center mb-4">
                <Iconify icon="eva:inbox-outline" width={32} className="text-gray-300" />
              </div>
              <p className="text-sm font-medium text-gray-900 mb-1">Nenhum template encontrado</p>
              <p className="text-xs text-gray-500 mb-4">
                {pesquisa ? 'Tente buscar com termos diferentes.' : 'Crie seu primeiro template para começar.'}
              </p>
              {!pesquisa && (
                <button onClick={handleNovo} className="text-sm text-[#7C3AED] font-medium hover:underline">
                  Criar template
                </button>
              )}
            </div>
          )}
        </GenericTable>
      </div>

      {/* Drawer */}
      {openDrawer && (
        <div className="fixed inset-0 z-[9999] flex justify-end overflow-hidden animate-in fade-in duration-200">
          {/* Backdrop */}
          <div
            className={TEMPLATES_WHATSAPP_DESIGN.drawer.backdrop}
            onClick={() => { setOpenDrawer(false); setError(null); }}
          />

          {/* Drawer Panel */}
          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.container}>
            {/* Drawer Header */}
            <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.header.container}>
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${
                  idEdit ? 'bg-green-50' : mostrarBiblioteca ? 'bg-blue-50' : 'bg-violet-50'
                }`}>
                  <Iconify
                    icon={idEdit ? 'eva:eye-outline' : mostrarBiblioteca ? 'eva:book-outline' : 'eva:edit-2-outline'}
                    width={18}
                    className={idEdit ? 'text-green-600' : mostrarBiblioteca ? 'text-blue-600' : 'text-violet-600'}
                  />
                </div>
                <div>
                  <h2 className={TEMPLATES_WHATSAPP_DESIGN.drawer.header.title}>
                    {idEdit ? (isEditing ? 'Editar Template' : 'Visualizar Template') : mostrarBiblioteca ? 'Biblioteca de Modelos' : 'Criar Novo Template'}
                  </h2>
                  {idEdit && nome && (
                    <p className={TEMPLATES_WHATSAPP_DESIGN.drawer.header.subtitle}>{nome}</p>
                  )}
                </div>
              </div>
              <button
                onClick={() => { setOpenDrawer(false); setError(null); }}
                className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
              >
                <Iconify icon="eva:close-outline" width={20} />
              </button>
            </div>

            {/* Error Banner */}
            {error && (
              <div className="px-6 py-3 bg-red-50 border-b border-red-100">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Iconify icon="eva:alert-circle-outline" width={14} className="text-red-500" />
                  </div>
                  <p className="text-sm text-red-700 flex-1">{error}</p>
                  <button
                    onClick={() => setError(null)}
                    className="text-red-400 hover:text-red-600 p-1 rounded hover:bg-red-100 transition-colors flex-shrink-0"
                  >
                    <Iconify icon="eva:close-outline" width={16} />
                  </button>
                </div>
              </div>
            )}

            {/* Content Area */}
            <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.content.container}>

              {/* ===== LIBRARY VIEW ===== */}
              {!idEdit && mostrarBiblioteca && (
                <div className="w-full p-6 overflow-y-auto">
                  <div className="max-w-7xl mx-auto">
                    {/* Library search + filters */}
                    <div className="mb-6 flex items-center gap-4">
                      <div className="flex-1 relative">
                        <Iconify icon="eva:search-outline" width={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <Input
                          placeholder="Pesquisar modelos..."
                          value={pesquisaBiblioteca}
                          onChange={(e) => setPesquisaBiblioteca(e.target.value)}
                          className="pl-10 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl"
                        />
                      </div>
                      <div className="flex items-center gap-2">
                        <Label className="text-sm font-medium text-gray-600 whitespace-nowrap">Categoria:</Label>
                        <Select value={categoriaFiltro} onValueChange={setCategoriaFiltro}>
                          <SelectTrigger className="w-[180px] border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl">
                            <SelectValue placeholder="Todas" />
                          </SelectTrigger>
                          <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                            <SelectItem value="all">
                              Todas ({templatesBiblioteca.length > 0
                                ? (paginacaoBiblioteca?.total || templatesBiblioteca.length)
                                : modelosPreProntos.length
                              })
                            </SelectItem>
                            <SelectItem value="UTILITY">
                              Utilidade ({templatesBiblioteca.length > 0
                                ? templatesBiblioteca.filter(t => t.category === 'UTILITY').length
                                : modelosPreProntos.filter(m => m.categoria === 'UTILITY').length
                              })
                            </SelectItem>
                            <SelectItem value="MARKETING">
                              Marketing ({templatesBiblioteca.length > 0
                                ? templatesBiblioteca.filter(t => t.category === 'MARKETING').length
                                : modelosPreProntos.filter(m => m.categoria === 'MARKETING').length
                              })
                            </SelectItem>
                            <SelectItem value="AUTHENTICATION">
                              Autenticação ({templatesBiblioteca.length > 0
                                ? templatesBiblioteca.filter(t => t.category === 'AUTHENTICATION').length
                                : modelosPreProntos.filter(m => m.categoria === 'AUTHENTICATION').length
                              })
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    {/* Library Grid */}
                    {loadingBiblioteca ? (
                      <div className="text-center py-16">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#7C3AED]"></div>
                        <p className="text-gray-500 mt-4 text-sm">Carregando templates...</p>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        {(() => {
                          let templatesParaExibir = [];

                          if (templatesBiblioteca.length > 0) {
                            templatesParaExibir = templatesBiblioteca
                              .map(t => transformarTemplateBiblioteca(t))
                              .filter(modelo => {
                                if (categoriaFiltro && categoriaFiltro !== 'all' && modelo.categoria !== categoriaFiltro) return false;
                                if (pesquisaBiblioteca) {
                                  const searchLower = pesquisaBiblioteca.toLowerCase();
                                  if (!modelo.nome.toLowerCase().includes(searchLower) &&
                                    !modelo.descricao.toLowerCase().includes(searchLower) &&
                                    !modelo.categoria.toLowerCase().includes(searchLower)) return false;
                                }
                                return true;
                              });
                          } else {
                            templatesParaExibir = modelosPreProntos.filter(modelo => {
                              if (categoriaFiltro && categoriaFiltro !== 'all' && modelo.categoria !== categoriaFiltro) return false;
                              if (pesquisaBiblioteca) {
                                const searchLower = pesquisaBiblioteca.toLowerCase();
                                if (!modelo.nome.toLowerCase().includes(searchLower) &&
                                  !modelo.descricao.toLowerCase().includes(searchLower) &&
                                  !modelo.categoria.toLowerCase().includes(searchLower)) return false;
                              }
                              return true;
                            });
                          }

                          if (templatesParaExibir.length === 0) {
                            return (
                              <div className="col-span-full text-center py-16">
                                <Iconify icon="eva:search-outline" width={48} className="text-gray-300 mx-auto mb-3" />
                                <p className="text-gray-500 text-sm">Nenhum modelo encontrado</p>
                              </div>
                            );
                          }

                          return templatesParaExibir.map((modelo) => (
                            <Card
                              key={modelo.id}
                              className={TEMPLATES_WHATSAPP_DESIGN.card.container}
                              onClick={() => aplicarModeloPrePronto(modelo)}
                            >
                              <CardContent className="p-0">
                                {/* WhatsApp Preview Mini */}
                                <div className="bg-[#efeae2] p-3 relative" style={{
                                  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a7a7a7' fill-opacity='0.08'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/svg%3E")`,
                                  backgroundSize: '30px 30px'
                                }}>
                                  <div className="flex justify-end">
                                    <div className="bg-[#d9fdd3] rounded-xl rounded-tr-sm p-2.5 shadow-sm max-w-[90%] min-w-[140px] relative">
                                      <div className="absolute -right-1 top-0 w-0 h-0 border-l-[6px] border-l-[#d9fdd3] border-t-[6px] border-t-transparent"></div>

                                      {modelo.headerText && (
                                        <div className="font-bold text-gray-800 mb-1.5 text-xs leading-tight">{modelo.headerText}</div>
                                      )}

                                      {modelo.conteudo ? (
                                        <div className="text-gray-700 text-[11px] mb-1.5 leading-relaxed">
                                          {modelo.conteudo.split('\n').slice(0, 3).map((line, index) => (
                                            <div key={index} className={index > 0 ? 'mt-0.5' : ''}>
                                              {line.length > 60 ? line.substring(0, 60) + '...' : line}
                                            </div>
                                          ))}
                                          {modelo.conteudo.split('\n').length > 3 && (
                                            <div className="text-gray-400 text-[10px] mt-0.5">...</div>
                                          )}
                                        </div>
                                      ) : (
                                        <div className="text-gray-400 text-[11px] italic min-h-[16px]">
                                          {modelo.descricao || modelo.nome}
                                        </div>
                                      )}

                                      {modelo.footerText && (
                                        <div className="text-[10px] text-gray-400 border-t border-gray-200/50 mt-1.5 pt-1">
                                          {modelo.footerText}
                                        </div>
                                      )}

                                      <div className="text-[9px] text-gray-400 text-right mt-1 flex items-center justify-end gap-0.5">
                                        {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                        <Iconify icon="eva:checkmark-circle-2-fill" width={8} className="text-blue-400" />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Quick reply buttons preview */}
                                  {modelo.buttons && modelo.buttons.length > 0 && (
                                    <div className="flex justify-end mt-1.5">
                                      <div className="max-w-[90%] min-w-[140px] space-y-1">
                                        {modelo.buttons.slice(0, 2).map((button, index) => (
                                          <div key={index} className="bg-white rounded-lg py-1.5 px-2 text-center shadow-sm">
                                            <span className="text-[10px] text-[#008069] font-medium flex items-center justify-center gap-1">
                                              {button.type === 'URL' && <Iconify icon="eva:external-link-outline" width={10} />}
                                              {button.type === 'PHONE_NUMBER' && <Iconify icon="eva:phone-outline" width={10} />}
                                              {button.text || `Botão ${index + 1}`}
                                            </span>
                                          </div>
                                        ))}
                                        {modelo.buttons.length > 2 && (
                                          <div className="text-[9px] text-gray-400 text-center">+{modelo.buttons.length - 2} mais</div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* Card Info */}
                                <div className="p-4">
                                  <div className="flex items-start justify-between gap-2 mb-2">
                                    <h3 className="font-semibold text-gray-900 text-sm leading-tight">{modelo.nome}</h3>
                                    <Badge variant="outline" className={`text-[10px] flex-shrink-0 ${
                                      modelo.categoria === 'MARKETING' ? 'text-blue-600 border-blue-200 bg-blue-50' :
                                      modelo.categoria === 'AUTHENTICATION' ? 'text-orange-600 border-orange-200 bg-orange-50' :
                                      'text-gray-600 border-gray-200 bg-gray-50'
                                    }`}>
                                      {transformCategoryTemplateWhatsApp(modelo.categoria)}
                                    </Badge>
                                  </div>
                                  <p className="text-xs text-gray-500 line-clamp-2 leading-relaxed">{modelo.descricao || 'Sem descrição'}</p>
                                  <div className="mt-3 pt-3 border-t border-gray-100">
                                    <span className="text-xs text-[#7C3AED] font-medium group-hover:underline">Usar modelo</span>
                                  </div>
                                </div>
                              </CardContent>
                            </Card>
                          ));
                        })()}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ===== FORM + PREVIEW VIEW ===== */}
              {(!mostrarBiblioteca || idEdit) && (
                <React.Fragment>
                  {/* Left Column - Form Editor */}
                  <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.content.leftColumn}>
                    {/* Basic Settings Section */}
                    <div className="bg-white rounded-xl border border-gray-100 p-5 mb-5">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-8 h-8 bg-violet-50 rounded-lg flex items-center justify-center">
                          <Iconify icon="eva:settings-2-outline" width={16} className="text-violet-600" />
                        </div>
                        <h3 className="text-sm font-bold text-gray-900">Configurações Básicas</h3>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="nome" className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                            Nome do Template *
                          </Label>
                          <Input
                            id="nome"
                            placeholder="Ex: Boas Vindas ao cliente"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            disabled={idEdit}
                            className={`text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="categoria" className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                            Categoria *
                          </Label>
                          <Select value={categoria} onValueChange={setCategoria} disabled={idEdit}>
                            <SelectTrigger className={`w-full border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit ? 'bg-gray-50 cursor-not-allowed' : ''}`}>
                              <SelectValue placeholder="Selecione a categoria" />
                            </SelectTrigger>
                            <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                              {['UTILITY', 'MARKETING', 'AUTHENTICATION'].map(category => (
                                <SelectItem key={category} value={category}>{transformCategoryTemplateWhatsApp(category)}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clienteIdTemplate" className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                            Canal WhatsApp *
                          </Label>
                          <Select
                            value={clienteIdTemplate}
                            onValueChange={(value) => {
                              setClienteIdTemplate(value);
                              setCanalFiltro(value);
                            }}
                            disabled={idEdit}
                          >
                            <SelectTrigger className={`w-full border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit ? 'bg-gray-50 cursor-not-allowed' : ''}`}>
                              <SelectValue placeholder="Selecione o canal" />
                            </SelectTrigger>
                            <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                              {canais.map((canal) => (
                                <SelectItem key={canal.cliente_id} value={canal.cliente_id}>
                                  {canal.nome}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                    </div>

                    {/* Template Editor Section */}
                    <div className="bg-gray-50/50 rounded-xl border border-gray-100 p-5">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-8 h-8 bg-violet-50 rounded-lg flex items-center justify-center">
                          <Iconify icon="eva:edit-2-outline" width={16} className="text-violet-600" />
                        </div>
                        <h3 className="text-sm font-bold text-gray-900">
                          {idEdit && !isEditing ? 'Conteúdo do Template' : 'Editor do Template'}
                        </h3>
                      </div>

                      <div className="space-y-5">
                        {/* Header */}
                        <div>
                          <div className="flex items-center gap-3 mb-3">
                            <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">Header</Label>
                            <Select value={headerType} onValueChange={(val) => { setHeaderType(val); setHeaderMedia(''); setHeaderMediaFileName(''); setHeaderMediaPreview(''); setHeaderMediaFile(null); setHeaderText(''); setHeaderMediaMode('upload'); }} disabled={idEdit && !isEditing}>
                              <SelectTrigger className={`w-36 text-xs h-8 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-lg ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}>
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                                <SelectItem value="none">Nenhum</SelectItem>
                                <SelectItem value="text">Texto</SelectItem>
                                <SelectItem value="image">Imagem</SelectItem>
                                <SelectItem value="video">Vídeo</SelectItem>
                                <SelectItem value="document">Documento</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>

                          {headerType === 'text' && (
                            <Input
                              placeholder="Texto do header (ex: Bem-vindo!)"
                              value={headerText}
                              onChange={(e) => setHeaderText(e.target.value)}
                              disabled={idEdit && !isEditing}
                              className={`font-semibold text-gray-800 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                            />
                          )}

                          {['image', 'video', 'document'].includes(headerType) && (
                            <div>
                              {/* Instruções de tamanho ideal */}
                              <div className="flex items-start gap-2 p-2.5 mb-3 bg-violet-50/60 border border-violet-100 rounded-lg">
                                <Iconify icon="eva:info-outline" width={15} className="text-violet-500 mt-0.5 flex-shrink-0" />
                                <div className="text-[11px] text-violet-700 leading-relaxed">
                                  {headerType === 'image' && (
                                    <>
                                      <span className="font-semibold">Tamanho ideal:</span> 820 x 312 px (proporção 2.63:1) &middot; Formatos: JPG, PNG &middot; Máx. 5 MB
                                    </>
                                  )}
                                  {headerType === 'video' && (
                                    <>
                                      <span className="font-semibold">Recomendações:</span> Até 16 MB &middot; Formato MP4 (H.264) &middot; Duração máx. 60s
                                    </>
                                  )}
                                  {headerType === 'document' && (
                                    <>
                                      <span className="font-semibold">Recomendações:</span> Até 100 MB &middot; Formato PDF recomendado
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Toggle upload / link */}
                              {(!idEdit || isEditing) && !headerMedia && !headerMediaPreview && (
                                <div className="flex items-center gap-1 mb-3 bg-gray-100 rounded-lg p-0.5 w-fit">
                                  <button
                                    type="button"
                                    onClick={() => setHeaderMediaMode('upload')}
                                    className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                                      headerMediaMode === 'upload'
                                        ? 'bg-white text-gray-900 shadow-sm'
                                        : 'text-gray-500 hover:text-gray-700'
                                    }`}
                                  >
                                    <Iconify icon="eva:cloud-upload-outline" width={14} />
                                    Upload
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => setHeaderMediaMode('link')}
                                    className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                                      headerMediaMode === 'link'
                                        ? 'bg-white text-gray-900 shadow-sm'
                                        : 'text-gray-500 hover:text-gray-700'
                                    }`}
                                  >
                                    <Iconify icon="eva:link-2-outline" width={14} />
                                    Link público
                                  </button>
                                </div>
                              )}

                              <input
                                type="file"
                                ref={headerFileInputRef}
                                className="hidden"
                                accept={
                                  headerType === 'image' ? 'image/jpeg,image/png,image/webp' :
                                  headerType === 'video' ? 'video/mp4,video/3gpp' :
                                  '.pdf,.doc,.docx,.xls,.xlsx'
                                }
                                onChange={(e) => {
                                  if (e.target.files?.[0]) handleHeaderFileUpload(e.target.files[0]);
                                }}
                                disabled={idEdit && !isEditing}
                              />

                              {(headerMedia || headerMediaPreview) ? (
                                <div className="relative">
                                  {headerType === 'image' && (headerMediaPreview || (headerMedia && !['file-selected', 'media-registered'].includes(headerMedia))) ? (
                                    <div className="w-full h-40 rounded-xl overflow-hidden mb-2 border border-gray-200">
                                      <img src={headerMediaPreview || headerMedia} alt="Header" className="w-full h-full object-cover" />
                                    </div>
                                  ) : headerType === 'image' && (
                                    <div className="w-full h-40 rounded-xl mb-2 border border-gray-200 bg-gradient-to-br from-violet-50 to-gray-50 flex flex-col items-center justify-center gap-2">
                                      <Iconify icon="eva:image-outline" width={32} className="text-violet-400" />
                                      <p className="text-xs text-gray-500 font-medium">Imagem cadastrada</p>
                                    </div>
                                  )}
                                  {headerType === 'video' && (headerMediaPreview || (headerMedia && !['file-selected', 'media-registered'].includes(headerMedia))) ? (
                                    <div className="w-full h-40 rounded-xl overflow-hidden mb-2 border border-gray-200 bg-black">
                                      <video src={headerMediaPreview || headerMedia} className="w-full h-full object-contain" controls />
                                    </div>
                                  ) : headerType === 'video' && (
                                    <div className="w-full h-40 rounded-xl mb-2 border border-gray-200 bg-gradient-to-br from-violet-50 to-gray-50 flex flex-col items-center justify-center gap-2">
                                      <Iconify icon="eva:video-outline" width={32} className="text-violet-400" />
                                      <p className="text-xs text-gray-500 font-medium">Vídeo cadastrado</p>
                                    </div>
                                  )}
                                  {headerType === 'document' && (
                                    <div className="w-full rounded-xl mb-2 border border-gray-200 bg-gray-50 p-4 flex items-center gap-3">
                                      <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                                        <Iconify icon="eva:file-text-outline" width={22} className="text-red-500" />
                                      </div>
                                      <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-700 truncate">{headerMediaFileName || 'Documento'}</p>
                                        <p className="text-xs text-gray-400">Arquivo carregado</p>
                                      </div>
                                    </div>
                                  )}

                                  {(!idEdit || isEditing) && (
                                    <div className="flex items-center gap-2">
                                      <button
                                        type="button"
                                        onClick={() => headerFileInputRef.current?.click()}
                                        className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                                      >
                                        <Iconify icon="eva:swap-outline" width={14} />
                                        Trocar arquivo
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => { setHeaderMedia(''); setHeaderMediaFileName(''); setHeaderMediaPreview(''); setHeaderMediaFile(null); }}
                                        className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-red-600 bg-white border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
                                      >
                                        <Iconify icon="eva:trash-2-outline" width={14} />
                                        Remover
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : headerMediaMode === 'link' ? (
                                <div className="space-y-2">
                                  <div className="relative">
                                    <div className="absolute left-3 top-1/2 -translate-y-1/2">
                                      <Iconify icon="eva:link-2-outline" width={16} className="text-gray-400" />
                                    </div>
                                    <Input
                                      placeholder={
                                        headerType === 'image' ? 'https://exemplo.com/imagem.jpg' :
                                        headerType === 'video' ? 'https://exemplo.com/video.mp4' :
                                        'https://exemplo.com/documento.pdf'
                                      }
                                      value={headerMedia}
                                      onChange={(e) => setHeaderMedia(e.target.value)}
                                      disabled={idEdit && !isEditing}
                                      className={`pl-9 text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                    />
                                  </div>
                                  <p className="text-[10px] text-gray-400 flex items-center gap-1">
                                    <Iconify icon="eva:info-outline" width={12} />
                                    O link deve ser público e acessível. {headerType === 'image' ? 'Formatos: JPG, PNG, WEBP' : headerType === 'video' ? 'Formatos: MP4, 3GP' : 'Formatos: PDF, DOC, XLS'}
                                  </p>
                                </div>
                              ) : (
                                <div
                                  className={`w-full h-36 rounded-xl flex flex-col items-center justify-center border-2 border-dashed transition-all duration-200 ${
                                    headerMediaUploading
                                      ? 'border-violet-300 bg-violet-50/50'
                                      : 'border-gray-200 bg-gradient-to-br from-gray-50 to-white hover:border-violet-300 hover:bg-violet-50/30 cursor-pointer'
                                  } ${idEdit && !isEditing ? 'opacity-50 pointer-events-none' : ''}`}
                                  onClick={() => !headerMediaUploading && !(idEdit && !isEditing) && headerFileInputRef.current?.click()}
                                  onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                  onDrop={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!(idEdit && !isEditing) && e.dataTransfer.files?.[0]) {
                                      handleHeaderFileUpload(e.dataTransfer.files[0]);
                                    }
                                  }}
                                >
                                  {headerMediaUploading ? (
                                    <>
                                      <div className="w-8 h-8 border-2 border-violet-400 border-t-transparent rounded-full animate-spin mb-2" />
                                      <p className="text-xs font-medium text-violet-600">Enviando arquivo...</p>
                                    </>
                                  ) : (
                                    <>
                                      <div className="w-12 h-12 rounded-xl bg-violet-50 flex items-center justify-center mb-2">
                                        <Iconify
                                          icon={headerType === 'image' ? 'eva:image-outline' : headerType === 'video' ? 'eva:video-outline' : 'eva:file-text-outline'}
                                          width={24}
                                          className="text-violet-400"
                                        />
                                      </div>
                                      <p className="text-xs font-medium text-gray-600">
                                        Clique ou arraste para enviar
                                      </p>
                                      <p className="text-[10px] text-gray-400 mt-1">
                                        {headerType === 'image' ? 'JPG, PNG ou WEBP (máx. 16MB)' :
                                         headerType === 'video' ? 'MP4 ou 3GP (máx. 16MB)' :
                                         'PDF, DOC ou XLS (máx. 100MB)'}
                                      </p>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <Separator className="bg-gray-200/60" />

                        {/* Body */}
                        <div>
                          <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3 block">
                            Corpo da mensagem *
                          </Label>
                          <div className="relative">
                            <Textarea
                              ref={textareaRef}
                              placeholder="Ex: Olá {{1}}, tudo bem? Podemos conversar sobre o seu problema?"
                              value={conteudo}
                              onChange={(e) => setConteudo(e.target.value)}
                              disabled={idEdit && !isEditing}
                              className={`text-sm min-h-[120px] resize-none border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                              rows={4}
                            />

                            {/* Formatting Toolbar */}
                            {(!idEdit || isEditing) && (
                              <div className="flex items-center gap-1 mt-2 p-1.5 bg-white rounded-lg border border-gray-200">
                                <button type="button" onClick={() => {
                                  const emoji = '😊';
                                  const textarea = textareaRef.current;
                                  if (!textarea) return;
                                  const start = textarea.selectionStart;
                                  const end = textarea.selectionEnd;
                                  const textoAntes = conteudo.substring(0, start);
                                  const textoDepois = conteudo.substring(end);
                                  setConteudo(textoAntes + emoji + textoDepois);
                                  setTimeout(() => {
                                    textarea.focus();
                                    textarea.setSelectionRange(start + emoji.length, start + emoji.length);
                                  }, 0);
                                }} className="p-1.5 hover:bg-gray-100 rounded-md transition-colors" title="Emoji">
                                  <Iconify icon="eva:smiling-face-outline" width={16} />
                                </button>

                                <Separator orientation="vertical" className="h-5 mx-0.5" />

                                <button type="button" onClick={() => aplicarFormatacao('bold')} className="p-1.5 hover:bg-gray-100 rounded-md transition-colors font-bold text-xs w-7 h-7 flex items-center justify-center" title="Negrito">B</button>
                                <button type="button" onClick={() => aplicarFormatacao('italic')} className="p-1.5 hover:bg-gray-100 rounded-md transition-colors italic text-xs w-7 h-7 flex items-center justify-center" title="Itálico">I</button>
                                <button type="button" onClick={() => aplicarFormatacao('strikethrough')} className="p-1.5 hover:bg-gray-100 rounded-md transition-colors line-through text-xs w-7 h-7 flex items-center justify-center" title="Riscado">S</button>
                                <button type="button" onClick={() => aplicarFormatacao('code')} className="p-1.5 hover:bg-gray-100 rounded-md transition-colors font-mono text-[10px] w-7 h-7 flex items-center justify-center" title="Código">&lt;/&gt;</button>

                                <Separator orientation="vertical" className="h-5 mx-0.5" />

                                <button type="button" onClick={adicionarProximaVariavel} className="flex items-center gap-1 px-2 py-1 hover:bg-violet-50 hover:text-violet-600 rounded-md transition-colors text-xs font-medium" title="Adicionar variável">
                                  <Iconify icon="eva:plus-outline" width={14} />
                                  Variável
                                </button>
                              </div>
                            )}
                          </div>

                          {/* Variable Samples */}
                          {Object.keys(variaveisTemplate).length > 0 && (
                            <div data-formulario-amostras className="mt-4 bg-violet-50/50 rounded-xl border border-violet-100 p-4">
                              <div className="mb-3">
                                <h4 className="text-xs font-bold text-gray-800 mb-1">
                                  Amostras de variáveis <span className="text-red-500">*</span>
                                </h4>
                                <p className="text-[11px] text-gray-500 leading-relaxed">
                                  Preencha exemplos para todas as variáveis. Não inclua informações reais de clientes.
                                </p>
                              </div>

                              <div className="space-y-2.5">
                                {Object.keys(variaveisTemplate)
                                  .sort((a, b) => parseInt(a) - parseInt(b))
                                  .map((variavel) => {
                                    const temErro = Boolean(errosValidacao[variavel]);
                                    const valor = variaveisTemplate[variavel] || '';

                                    return (
                                      <div key={variavel} className="flex items-center gap-2">
                                        <div className="flex-shrink-0 w-16">
                                          <span className="inline-flex items-center justify-center h-8 px-2 bg-violet-100 text-violet-700 text-xs font-mono rounded-lg w-full">
                                            {`{{${variavel}}}`}
                                          </span>
                                        </div>
                                        <div className="flex-1">
                                          <Input
                                            value={valor}
                                            onChange={(e) => handleAtualizarVariavel(variavel, e.target.value)}
                                            placeholder={`Exemplo para {{${variavel}}}`}
                                            disabled={idEdit && !isEditing}
                                            className={`h-8 text-sm ${temErro
                                              ? 'border-red-400 focus:border-red-400 focus:ring-red-400/20 bg-red-50/50'
                                              : 'border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20'
                                            } ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                          />
                                          {temErro && (
                                            <span className="text-[10px] text-red-500 mt-0.5 block">{errosValidacao[variavel]}</span>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                        </div>

                        <Separator className="bg-gray-200/60" />

                        {/* Footer */}
                        <div>
                          <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3 block">Footer</Label>
                          <Input
                            placeholder="Texto do footer (opcional)"
                            value={footerText}
                            onChange={(e) => setFooterText(e.target.value)}
                            disabled={idEdit && !isEditing}
                            className={`text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                          />
                        </div>

                        <Separator className="bg-gray-200/60" />

                        {/* Buttons */}
                        <div>
                          <div className="flex items-center justify-between mb-3">
                            <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">Botões</Label>
                            {(!idEdit || isEditing) && (
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => setButtons([...buttons, { type: 'QUICK_REPLY', text: '' }])}
                                className="h-7 text-xs border-gray-200 hover:bg-violet-50 hover:border-violet-200 text-violet-600 rounded-lg"
                              >
                                <Iconify icon="eva:plus-outline" width={14} className="mr-1" />
                                Botão
                              </Button>
                            )}
                          </div>

                          <div className="space-y-2.5">
                            {buttons.map((button, index) => (
                              <div key={index}>
                                <div className="flex items-center gap-2 p-3 bg-white rounded-xl border border-gray-200 hover:border-gray-300 transition-colors">
                                  <Select
                                    value={button.type}
                                    onValueChange={(value) => {
                                      const newButtons = [...buttons];
                                      const updatedButton = { ...newButtons[index], type: value };
                                      if (value === 'PHONE_NUMBER') {
                                        updatedButton.phone_number = updatedButton.phone_number || '';
                                        delete updatedButton.url;
                                      } else if (value === 'URL') {
                                        updatedButton.url = updatedButton.url || '';
                                        delete updatedButton.phone_number;
                                      } else {
                                        delete updatedButton.url;
                                        delete updatedButton.phone_number;
                                      }
                                      newButtons[index] = updatedButton;
                                      setButtons(newButtons);
                                    }}
                                    disabled={idEdit && !isEditing}
                                  >
                                    <SelectTrigger className={`w-28 h-8 text-xs border-gray-200 rounded-lg ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}>
                                      <SelectValue />
                                    </SelectTrigger>
                                    <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                                      <SelectItem value="QUICK_REPLY">Resposta</SelectItem>
                                      <SelectItem value="URL">URL</SelectItem>
                                      <SelectItem value="PHONE_NUMBER">Telefone</SelectItem>
                                    </SelectContent>
                                  </Select>

                                  <Input
                                    placeholder="Texto do botão"
                                    value={button.text}
                                    onChange={(e) => {
                                      const newButtons = [...buttons];
                                      newButtons[index] = { ...newButtons[index], text: e.target.value };
                                      setButtons(newButtons);
                                    }}
                                    disabled={idEdit && !isEditing}
                                    className={`flex-1 h-8 text-sm border-gray-200 rounded-lg ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                  />

                                  {button.type === 'URL' && (
                                    <Input
                                      placeholder="https://..."
                                      value={button.url || ''}
                                      onChange={(e) => {
                                        const newButtons = [...buttons];
                                        newButtons[index] = { ...newButtons[index], url: e.target.value };
                                        setButtons(newButtons);
                                      }}
                                      disabled={idEdit && !isEditing}
                                      className={`w-40 h-8 text-sm border-gray-200 rounded-lg ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                    />
                                  )}

                                  {button.type === 'PHONE_NUMBER' && (
                                    <Input
                                      placeholder="+5511999999999"
                                      value={button.phone_number || ''}
                                      onChange={(e) => {
                                        let valor = e.target.value.trim();
                                        if (valor && !valor.startsWith('+')) {
                                          if (/^\d/.test(valor)) {
                                            valor = '+' + valor;
                                          } else {
                                            valor = '+' + valor.replace(/[^\d+]/g, '');
                                          }
                                        }
                                        valor = valor.replace(/[^\d+]/g, '');
                                        if (valor.length > 16) {
                                          valor = valor.substring(0, 16);
                                        }
                                        const newButtons = [...buttons];
                                        newButtons[index] = { ...newButtons[index], phone_number: valor };
                                        setButtons(newButtons);
                                      }}
                                      disabled={idEdit && !isEditing}
                                      className={`w-44 h-8 text-sm border-gray-200 rounded-lg ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                    />
                                  )}

                                  {(!idEdit || isEditing) && (
                                    <button
                                      onClick={() => setButtons(buttons.filter((_, i) => i !== index))}
                                      className="w-7 h-7 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors flex-shrink-0"
                                    >
                                      <Iconify icon="eva:close-outline" width={14} />
                                    </button>
                                  )}
                                </div>
                                {button.type === 'PHONE_NUMBER' && (
                                  <p className="text-[10px] text-gray-400 mt-1 ml-2">Formato E.164: +[código do país][número]</p>
                                )}
                                {/* Amostras de variáveis da URL do botão */}
                                {button.type === 'URL' && button.url && extrairVariaveisDaBotaoUrl(button.url).length > 0 && (
                                  <div className="mt-2 ml-2 bg-violet-50/50 rounded-lg border border-violet-100 p-3">
                                    <p className="text-[10px] font-semibold text-gray-600 mb-2 uppercase tracking-wider">
                                      Amostras de variáveis da URL
                                    </p>
                                    <p className="text-[10px] text-gray-400 mb-2">
                                      Informe apenas a parte dinâmica, não a URL completa.
                                    </p>
                                    <div className="space-y-1.5">
                                      {extrairVariaveisDaBotaoUrl(button.url).map((varNum) => {
                                        // Extrair o trecho estático antes da variável para mostrar como contexto
                                        const partes = button.url.split(`{{${varNum}}}`);
                                        const prefixo = partes[0] || '';
                                        return (
                                        <div key={varNum}>
                                          <div className="flex items-center gap-2">
                                            <span className="flex-shrink-0 inline-flex items-center justify-center h-7 px-2 bg-violet-100 text-violet-700 text-[10px] font-mono rounded-md">
                                              {`{{${varNum}}}`}
                                            </span>
                                            <Input
                                              value={(variaveisBotoes[index] && variaveisBotoes[index][varNum]) || ''}
                                              onChange={(e) => {
                                                setVariaveisBotoes(prev => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...(prev[index] || {}),
                                                    [varNum]: e.target.value
                                                  }
                                                }));
                                              }}
                                              placeholder={`Ex: abc123`}
                                              disabled={idEdit && !isEditing}
                                              className={`flex-1 h-7 text-xs border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-md ${idEdit && !isEditing ? 'bg-gray-50 cursor-not-allowed' : ''}`}
                                            />
                                          </div>
                                          {prefixo && (
                                            <p className="text-[9px] text-gray-400 mt-0.5 ml-16 font-mono truncate">
                                              Resultado: {prefixo}<span className="text-violet-600 font-semibold">{(variaveisBotoes[index] && variaveisBotoes[index][varNum]) || `{{${varNum}}}`}</span>{partes[1] || ''}
                                            </p>
                                          )}
                                        </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}

                            {buttons.length === 0 && (
                              <div className="text-center py-4 text-gray-400">
                                <p className="text-xs">Nenhum botão adicionado</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Phone Preview */}
                  <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.content.rightColumn}>
                    <div className="sticky top-0">
                      <h3 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-4">Prévia</h3>

                      {/* Phone Mockup */}
                      <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.phoneFrame}>
                        <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.phoneInner}>
                          {/* Notch */}
                          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.notch}>
                            <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.notchPill}></div>
                          </div>

                          {/* WhatsApp Header */}
                          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.whatsappHeader}>
                            <Iconify icon="eva:arrow-back-outline" width={16} className="text-white/70" />
                            <div className="w-7 h-7 bg-white/20 rounded-full flex items-center justify-center">
                              <Iconify icon="eva:person-outline" width={14} className="text-white/60" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-white text-xs font-medium truncate">Destinatário</p>
                              <p className="text-green-200 text-[10px]">online</p>
                            </div>
                            <Iconify icon="eva:video-outline" width={16} className="text-white/60" />
                            <Iconify icon="eva:phone-outline" width={16} className="text-white/60" />
                          </div>

                          {/* Chat Area */}
                          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.chatArea} style={{
                            background: '#efeae2',
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a7a7a7' fill-opacity='0.08'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/svg%3E")`,
                            backgroundSize: '30px 30px'
                          }}>
                            {(conteudo || headerText || headerMedia || headerMediaPreview || footerText || buttons.length > 0) ? (
                              <>
                                <div className="flex justify-end">
                                  <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.messageBubble}>
                                    <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.messageTail}></div>

                                    {/* Header */}
                                    {headerType !== 'none' && (
                                      <div className="mb-1.5">
                                        {headerType === 'image' && (headerMediaPreview || (headerMedia && !['file-selected', 'media-registered'].includes(headerMedia))) ? (
                                          <div className="w-full h-24 rounded-lg overflow-hidden mb-1.5">
                                            <img src={headerMediaPreview || headerMedia} alt="Header" className="w-full h-full object-cover" />
                                          </div>
                                        ) : headerType === 'image' && (headerMedia || headerMediaPreview) ? (
                                          <div className="w-full h-24 bg-gradient-to-br from-violet-50 to-gray-100 rounded-lg flex items-center justify-center mb-1.5">
                                            <Iconify icon="eva:image-outline" width={22} className="text-violet-400" />
                                          </div>
                                        ) : headerType === 'image' ? (
                                          <div className="w-full h-24 bg-gray-200 rounded-lg flex items-center justify-center mb-1.5">
                                            <Iconify icon="eva:image-outline" width={20} className="text-gray-400" />
                                          </div>
                                        ) : null}
                                        {headerType === 'text' && headerText && (
                                          <div className="font-bold text-gray-900 text-sm leading-tight">{headerText}</div>
                                        )}
                                        {headerType === 'video' && (headerMedia || headerMediaPreview) ? (
                                          <div className="w-full h-24 rounded-lg overflow-hidden mb-1.5 bg-black flex items-center justify-center relative">
                                            <Iconify icon="eva:play-circle-fill" width={28} className="text-white/80" />
                                          </div>
                                        ) : headerType === 'video' ? (
                                          <div className="w-full h-24 bg-gray-200 rounded-lg flex items-center justify-center mb-1.5">
                                            <Iconify icon="eva:video-outline" width={20} className="text-gray-400" />
                                          </div>
                                        ) : null}
                                        {headerType === 'document' && (headerMedia || headerMediaPreview) ? (
                                          <div className="w-full rounded-lg bg-white border border-gray-200 p-2 flex items-center gap-2 mb-1.5">
                                            <div className="w-8 h-8 rounded bg-red-50 flex items-center justify-center flex-shrink-0">
                                              <Iconify icon="eva:file-text-outline" width={16} className="text-red-500" />
                                            </div>
                                            <div className="min-w-0 flex-1">
                                              <p className="text-[10px] font-medium text-gray-700 truncate">{headerMediaFileName || 'Documento'}</p>
                                              <p className="text-[9px] text-gray-400">PDF</p>
                                            </div>
                                          </div>
                                        ) : headerType === 'document' ? (
                                          <div className="w-full h-20 bg-gray-200 rounded-lg flex items-center justify-center mb-1.5">
                                            <Iconify icon="eva:file-outline" width={20} className="text-gray-400" />
                                          </div>
                                        ) : null}
                                      </div>
                                    )}

                                    {/* Body */}
                                    {conteudo && (
                                      <div className="text-gray-800 text-[12px] mb-1 leading-relaxed">
                                        {conteudo.split('\n').map((line, index) => (
                                          <div key={index} className={index > 0 ? 'mt-0.5' : ''}>
                                            {line.split(/(\{\{[^}]+\}\})/).map((part, partIndex) => {
                                              if (part.match(/\{\{[^}]+\}\}/)) {
                                                const isNumber = part.match(/\{\{(\d+)\}\}/);
                                                return (
                                                  <span
                                                    key={partIndex}
                                                    className="bg-blue-100/80 text-blue-700 px-1 py-px rounded text-[10px] font-semibold mx-0.5"
                                                  >
                                                    {isNumber ? `{{${isNumber[1]}}}` : part.replace(/\{\{|\}\}/g, '')}
                                                  </span>
                                                );
                                              }
                                              return part;
                                            })}
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    {/* Footer */}
                                    {footerText && (
                                      <div className="text-[10px] text-gray-400 border-t border-gray-200/40 mt-1.5 pt-1">
                                        {footerText}
                                      </div>
                                    )}

                                    {/* Timestamp */}
                                    <div className="text-[9px] text-gray-400 text-right mt-1 flex items-center justify-end gap-0.5">
                                      {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                      <Iconify icon="eva:checkmark-circle-2-fill" width={8} className="text-blue-400" />
                                    </div>
                                  </div>
                                </div>

                                {/* WhatsApp-style buttons (below bubble) */}
                                {buttons.length > 0 && (
                                  <div className="flex justify-end mt-1">
                                    <div className="max-w-[88%] min-w-[160px] space-y-1">
                                      {buttons.map((button, index) => (
                                        <div key={index} className="bg-white rounded-lg py-1.5 px-2 text-center shadow-sm">
                                          <span className="text-[11px] text-[#008069] font-medium flex items-center justify-center gap-1">
                                            {button.type === 'URL' && <Iconify icon="eva:external-link-outline" width={11} />}
                                            {button.type === 'PHONE_NUMBER' && <Iconify icon="eva:phone-outline" width={11} />}
                                            {button.text || `Botão ${index + 1}`}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-400">
                                  <div className="w-10 h-10 bg-white/60 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <Iconify icon="eva:message-circle-outline" width={20} />
                                  </div>
                                  <p className="text-[11px]">Comece a editar</p>
                                  <p className="text-[10px] text-gray-300">para ver a prévia</p>
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Input Bar */}
                          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.inputBar}>
                            <Iconify icon="eva:smiling-face-outline" width={18} className="text-gray-500" />
                            <div className="flex-1 bg-white rounded-full px-3 py-1.5">
                              <span className="text-[10px] text-gray-400">Mensagem</span>
                            </div>
                            <div className="w-7 h-7 bg-[#008069] rounded-full flex items-center justify-center">
                              <Iconify icon="eva:mic-outline" width={13} className="text-white" />
                            </div>
                          </div>

                          {/* Home Indicator */}
                          <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.preview.homeIndicator}>
                            <div className="w-28 h-1 bg-gray-700 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* Template Info Card */}
                      {(nome || categoria || lingua) && (
                        <div className="mt-4 bg-white rounded-xl border border-gray-200 p-3.5 space-y-2">
                          {nome && (
                            <div className="flex items-center justify-between">
                              <span className="text-[11px] text-gray-500">Nome</span>
                              <span className="text-[11px] font-medium text-gray-900 truncate ml-2 max-w-[60%] text-right">{nome}</span>
                            </div>
                          )}
                          {categoria && (
                            <div className="flex items-center justify-between">
                              <span className="text-[11px] text-gray-500">Categoria</span>
                              <Badge variant="outline" className="text-[10px] h-5">
                                {transformCategoryTemplateWhatsApp(categoria)}
                              </Badge>
                            </div>
                          )}
                          {lingua && (
                            <div className="flex items-center justify-between">
                              <span className="text-[11px] text-gray-500">Idioma</span>
                              <span className="text-[11px] font-medium text-gray-900">{lingua}</span>
                            </div>
                          )}
                          {buttons.length > 0 && (
                            <div className="flex items-center justify-between">
                              <span className="text-[11px] text-gray-500">Botões</span>
                              <span className="text-[11px] font-medium text-gray-900">{buttons.length}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>

            {/* Footer Action Bar */}
            <div className={TEMPLATES_WHATSAPP_DESIGN.drawer.footer.container}>
              <div>
                {!idEdit && !mostrarBiblioteca && (
                  <Button
                    variant="ghost"
                    onClick={() => { setMostrarBiblioteca(true); setPesquisaBiblioteca(''); }}
                    className="text-gray-500 hover:text-gray-700 rounded-xl px-3 py-2 h-auto text-sm"
                  >
                    <Iconify icon="eva:book-outline" width={16} className="mr-1.5" />
                    Usar modelo
                  </Button>
                )}
                {!idEdit && mostrarBiblioteca && (
                  <Button
                    variant="ghost"
                    onClick={() => setMostrarBiblioteca(false)}
                    className="text-gray-500 hover:text-gray-700 rounded-xl px-3 py-2 h-auto text-sm"
                  >
                    <Iconify icon="eva:arrow-back-outline" width={16} className="mr-1.5" />
                    Criar do zero
                  </Button>
                )}
                {idEdit && !isEditing && (
                  <Button
                    onClick={() => handleDeletar(idEdit)}
                    variant="ghost"
                    className="text-red-500 hover:text-red-700 hover:bg-red-50 rounded-xl px-3 py-2 h-auto text-sm"
                  >
                    <Iconify icon="eva:trash-2-outline" width={16} className="mr-1.5" />
                    Excluir
                  </Button>
                )}
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="ghost"
                  onClick={() => { setOpenDrawer(false); setError(null); }}
                  className="text-gray-500 hover:text-gray-700 rounded-xl px-4 py-2 h-auto text-sm"
                >
                  Cancelar
                </Button>
                {idEdit && !isEditing ? (
                  <Button
                    onClick={() => setIsEditing(true)}
                    className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white rounded-xl px-5 py-2 h-auto text-sm font-medium shadow-sm shadow-[#7C3AED]/20"
                  >
                    <Iconify icon="eva:edit-outline" width={16} className="mr-1.5" />
                    Editar
                  </Button>
                ) : !mostrarBiblioteca ? (
                  <ButtonLoading
                    loading={loading}
                    onClick={handleSalvar}
                    className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white rounded-xl px-5 py-2 h-auto text-sm font-medium shadow-sm shadow-[#7C3AED]/20"
                  >
                    <Iconify icon="eva:save-outline" width={16} className="mr-1.5" />
                    {idEdit && isEditing ? 'Salvar Alterações' : 'Criar Template'}
                  </ButtonLoading>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
